<template>
  <main-layout :selectedMenu="'myHome'">
    <div class="container">
      <asideCom :activityIndex="8"></asideCom>
      <div class="my-content">
        <div class="header">
          <h4>{{$t('global.我的文章')}}</h4>
          <router-link to="/article/edit">{{$t('global.写文章')}}</router-link>
        </div>
        <ul class="top">
          <li v-for="item in statusList" :key="item.id">
            <span :class="{active:item.id===status}" @click="changeStatus(item.id)">{{item.text}}</span>
          </li>
        </ul>
        <el-table :data="articleList" style="width: 100%;border: 1px solid #E0E0E0;" v-if="isShow">
          <el-table-column prop="title" label="文章名称">
            <template slot-scope="scope">
              <router-link
                :to="scope.row.status<2?`/article/preview/${scope.row.id}`:`/article/detail/${scope.row.id}`"
                class="title"
              >{{scope.row.title || '未命名'}}</router-link>
            </template>
          </el-table-column>
          <el-table-column label="更新时间" width="180">
            <template slot-scope="scope">
              <span>{{scope.row.updateTime | formatDate}}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="180">
            <template slot-scope="scope">
              <span>{{scope.row.createTime | formatDate}}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="80">
            <template slot-scope="scope">
              <span
                :class="{color2:scope.row.status===2,color3:scope.row.status===3,color1:scope.row.status===1,color0:scope.row.status===0}"
              >{{statusText[scope.row.status]}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <router-link :to="`/article/edit?id=${scope.row.id}`">{{$t('global.编辑')}}</router-link>
              <el-button
                slot="reference"
                type="text"
                size="small"
                @click="deleteArticle(scope.row.id)"
              >{{$t('global.删除')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :totalRecord="totalRecord"
          :pageSize="pageSize"
          :pageIndex="pageIndex"
          @OnCurrentChanged="changePage"
        />
      </div>
    </div>
  </main-layout>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import asideCom from "@/components/aside.vue";
import Pagination from "@/components/v2/Pagination";

export default {
  name: "manageVideo",
  metaInfo() {
    return {
      title: this.$t("global.我的文章") + " | MANA"
    };
  },
  data() {
    return {
      articleList: [],
      pageSize: 10,
      pageIndex: 1,
      totalRecord: 0,
      status: 4,
      isShow: false,
      statusList: [
        {
          id: 4,
          text: "全部"
        },
        {
          id: 2,
          text: "已发布"
        },
        {
          id: 1,
          text: "审核中"
        },
        {
          id: 0,
          text: "草稿"
        }
      ],
      statusText: ["草稿", "审核中", "已发布", "未通过"]
    };
  },
  components: {
    MainLayout,
    asideCom,
    Pagination
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.status = this.$route.query.status === "-1" ? 0 : 4;
      this.myArticle();
    },
    deleteArticle(id) {
      if (confirm("确定删除这篇文章?")) {
        const url = `/api/u/topicquestion/delete`;
        const params = { topicQuestionId: id };
        this.$http.post(url, params).then(res => {
          if (res.code === "OK") {
            this.$message.success(res.message);
            this.myArticle();
          }
        });
      }
    },
    changeStatus(id) {
      this.status = id;
      this.pageIndex = 1;
      this.articleList = [];
      this.totalRecord = 0;
      this.isShow = false;
      this.myArticle();
    },
    myArticle() {
      const url = `/api/u/topicquestion/getMyArticlePage`;
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        status: this.status
      };
      this.$http.get(url, { params }).then(res => {
        if (res.code === "OK") {
          this.articleList = res.data.list;
          this.totalRecord = res.data.totalRecord;
          this.isShow = true;
        }
      });
    },
    changePage(val) {
      this.pageIndex = val;
      this.myArticle();
    }
  }
};
</script>

<style lang="stylus"  scoped>
.body{
  background: #FAFAFA;
}
.container {
  width: 1110px;
  padding: 40px 0 120px 0;
  display: flex;
  margin: 0 auto;
  background: #FAFAFA;

  table {
    span {
      font-size: 12px;
      color: #999;
    }

    .title {
      font-size: 12px;
      color: #333333;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    a {
      color: #446EEB;
      font-size: 12px;
    }

    button {
      color: #446EEB;
    }
  }

  .color0 {
    color: #999999;
  }

  .color1 {
    color: #EABC2C;
  }

  .color2 {
    color: #4A8F00;
  }

  .color3 {
    color: #E42323;
  }

  .my-content {
    width: 825px;
    padding-top: 16px;
    box-sizing: border-box;

    .header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      h4 {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3A3A3A;
      }

      a {
        background: #2026CC;
        color: #fff;
        font-size: 16px;
        padding: 5px 10px;
        margin-right: 20px;

        &::before {
          content: '';
          display: inline-block;
          width: 20px;
          height: 20px;
          background: url('/static/v2/article/article_write_icon.png') no-repeat;
          background-size: 20px;
          vertical-align: bottom;
          margin-right: 8px;
        }
      }
    }

    .top {
      padding: 20px 0 0;
      margin-bottom: 20px;
      display: flex;
      flex-direction: row;
      border-bottom: 1px solid #E3E3E3;

      li {
        margin-right: 40px;

        span {
          cursor: pointer;
          font-size: 14px;
          color: #999;
          line-height: 40px;
          display: inline-block;
          height: 39px;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;

          &.active {
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333;
            border-bottom: 2px solid #000000;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/my/account/MyArticle.vue